module.exports = __webpack_public_path__ + "img/logo3.a3866ad7.jpg";